import { useParams } from "react-router-dom";
import "../Logo-Cards-Container/logo_cards.css";
import "../Logo-Cards-Container/card_details.css";
import "../../assets/workImages/work1.jpg";
import { Link } from "react-router-dom";

const OurWorksCardDetails = ({ name }) => {
  const { index } = useParams();
  const data = name[parseInt(index)];
  return (
    <>
      <div className="card_details_container">
        <video
          className="absolute -z-3 w-full h-[500px] object-cover opacity-50"
          src="/glowing_wave.mp4"
          autoPlay={true}
          loop
        ></video>
        <div className="card_details_wrapper static z-10 flex flex-col items-center pt-2 w-fit">
          <div className="back_and_socials flex justify-between items-center w-full mb-4">
            <div className="go_back w-16 ml-7">
              <Link
                to="/works"
                className="flex justify-center gap-1 items-center"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1.75em"
                  height="1.75em"
                  viewBox="0 0 24 24"
                >
                  <rect width="24" height="24" fill="none" />
                  <path
                    fill="#fff"
                    fill-rule="evenodd"
                    d="M10.53 5.47a.75.75 0 0 1 0 1.06l-4.72 4.72H20a.75.75 0 0 1 0 1.5H5.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0"
                    clip-rule="evenodd"
                  />
                </svg>
                <span>Back</span>
              </Link>
            </div>
            <div className="company_title_and_details">
              <div className="mx-auto flex w-20 justify-center gap-2 items-center">
                <a className="cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5rem"
                    height="1.5rem"
                    viewBox="0 0 24 24"
                  >
                    <rect width="24" height="24" fill="none" />
                    <path
                      fill="#777"
                      d="M17 3.5a.5.5 0 0 0-.5-.5H14a4.77 4.77 0 0 0-5 4.5v2.7H6.5a.5.5 0 0 0-.5.5v2.6a.5.5 0 0 0 .5.5H9v6.7a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-6.7h2.62a.5.5 0 0 0 .49-.37l.72-2.6a.5.5 0 0 0-.48-.63H13V7.5a1 1 0 0 1 1-.9h2.5a.5.5 0 0 0 .5-.5Z"
                    />
                  </svg>
                </a>

                <a className="cursor-pointer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.5rem"
                    height="1.5rem"
                    viewBox="0 0 24 24"
                  >
                    <rect width="24" height="24" fill="none" />
                    <path
                      fill="#777"
                      d="M13.028 2c1.125.003 1.696.009 2.189.023l.194.007c.224.008.445.018.712.03c1.064.05 1.79.218 2.427.465c.66.254 1.216.598 1.772 1.153a4.9 4.9 0 0 1 1.153 1.772c.247.637.415 1.363.465 2.428c.012.266.022.487.03.712l.006.194c.015.492.021 1.063.023 2.188l.001.746v1.31a79 79 0 0 1-.023 2.188l-.006.194c-.008.225-.018.446-.03.712c-.05 1.065-.22 1.79-.466 2.428a4.9 4.9 0 0 1-1.153 1.772a4.9 4.9 0 0 1-1.772 1.153c-.637.247-1.363.415-2.427.465l-.712.03l-.194.006c-.493.014-1.064.021-2.189.023l-.746.001h-1.309a78 78 0 0 1-2.189-.023l-.194-.006a63 63 0 0 1-.712-.031c-1.064-.05-1.79-.218-2.428-.465a4.9 4.9 0 0 1-1.771-1.153a4.9 4.9 0 0 1-1.154-1.772c-.247-.637-.415-1.363-.465-2.428l-.03-.712l-.005-.194A79 79 0 0 1 2 13.028v-2.056a79 79 0 0 1 .022-2.188l.007-.194c.008-.225.018-.446.03-.712c.05-1.065.218-1.79.465-2.428A4.9 4.9 0 0 1 3.68 3.678a4.9 4.9 0 0 1 1.77-1.153c.638-.247 1.363-.415 2.428-.465c.266-.012.488-.022.712-.03l.194-.006a79 79 0 0 1 2.188-.023zM12 7a5 5 0 1 0 0 10a5 5 0 0 0 0-10m0 2a3 3 0 1 1 .001 6a3 3 0 0 1 0-6m5.25-3.5a1.25 1.25 0 0 0 0 2.5a1.25 1.25 0 0 0 0-2.5"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
          <img className="card_logo_image" src={data.image} alt="Logo_img" />
          <h2 className="company_title">{data.companyName}</h2>
          <p className="p-3 text-center text-zinc-200">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Sit vitae
            repudiandae quae. Aliquam, impedit! Tempora quasi quibusdam
          </p>
        </div>
      </div>

      {/* <div className="presentation_container">
        <h3 className="font-bold">Logo Presentation</h3>
        <div className="logo_presentation_wrapper">
          <img className="item1" src="/img1.jpg" alt="img" />
          <img className="item2" src="/img2.jpg" alt="img" />
          <img className="item3" src="/img3.jpg" alt="img" />
          <img className="item4" src="/img4.jpg" alt="img" />
          <img className="item5" src="/img5.jpg" alt="img" />
          <img className="item6" src="/img6.jpg" alt="img" />
          <img className="item7" src="/img15.jpg" alt="img" />
          <img className="item8" src="/img12.jpg" alt="img" />
          <img className="item9" src="/img9.jpg" alt="img" />
          <img className="item10" src="/img10.jpg" alt="img" />
          <div className="presentation_gradient_container"></div>
        </div>
      </div> */}
    </>
  );
};

export default OurWorksCardDetails;
